<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <textarea
      class="form-control"
      :value="value"
      :placeholder="placeholder"
      :rows="rows"
      :class="{
        'is-invalid': field.$error,
        'is-valid': !field.$invalid,
      }"
      v-on:input="updateValue($event.target.value)"
    ></textarea>
  </div>
</template>
<script>
export default {
  props: ["label", "placeholder", "field", "value", "vmask", "rows"],
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
</script>